<form
  class="kLoginForm"
  [class.kResize]="showAuthenticationCode"
  [class.kError]="errorMessage && !showAuthenticationCode"
  [formGroup]="_loginForm"
  (submit)="_login($event)"
>
  <h1>{{ 'app.login.login.title' | translate }}</h1>

  <div>
    <input
      pInputText
      autocomplete="off"
      [placeholder]="'app.login.login.placeholder.username' | translate"
      [formControl]="_usernameField"
      [ngClass]="{
        'has-error': _showError(_usernameField),
        'has-success': _showSuccess(_usernameField)
      }"
      [kTooltip]="_loginValidationMessage | translate"
      placement="right"
    />
  </div>

  <div>
    <input
      type="password"
      autocomplete="off"
      appPreventPasswordAutofill
      pInputText
      [placeholder]="'app.login.login.placeholder.password' | translate"
      [formControl]="_passwordField"
      [class.has-error]="_showError(_passwordField)"
    />
  </div>

  <div [class.kHidden]="!showAuthenticationCode">
    <input
      pInputText
      class="kAuth"
      #auth
      autocomplete="off"
      [placeholder]="'app.login.login.placeholder.auth' | translate"
      [formControl]="_authenticationField"
      [ngClass]="{
        'has-error': _showError(_authenticationField),
        'has-success': _showSuccess(_authenticationField)
      }"
    />
    <span class="kAuthHelp" [kTooltip]="'app.login.login.authHelpTooltip' | translate">{{
      'app.login.login.authHelp' | translate
    }}</span>
  </div>

  <p
    *ngIf="
      errorMessage &&
      _errorCode !== 'LOGIN_BLOCKED' &&
      _errorCode !== 'LOGIN_RETRIES_EXCEEDED' &&
      _errorCode !== 'MISSING_OTP'
    "
    class="kErrorMessage"
    [innerHTML]="errorMessage"
  ></p>
  <p *ngIf="_errorCode === 'LOGIN_BLOCKED'" class="kErrorMessage">
    {{ 'app.login.error.loginBlocked.loginDenied' | translate }}
    <a (click)="_contactSupport()">{{ _supportAddress }}</a>
    {{ 'app.login.error.loginBlocked.toUnblockYourAccount' | translate }}
  </p>
  <p *ngIf="_errorCode === 'LOGIN_RETRIES_EXCEEDED'" class="kErrorMessage">
    {{ 'app.login.error.retriesExceeded.yourAccountHasBeenLocked' | translate }}
    <a *ngIf="_supportAddress" (click)="_contactSupport()">{{ _supportAddress }}</a>
    {{ 'app.login.error.retriesExceeded.toUnblockYourAccount' | translate }}
  </p>

  <div class="kControlLinks">
    <p-checkbox
      [formControl]="_rememberMeField"
      [binary]="true"
      [label]="'app.login.rememberMe' | translate"
    ></p-checkbox>
    <a (click)="_forgotPassword()">{{ 'app.login.login.forgotPassword' | translate }}</a>
  </div>

  <div class="kLoginButton">
    <button class="kButtonDefault" pButton [label]="_loginBtnText | translate" [disabled]="inProgress"></button>
  </div>
</form>
